import { createElement, lazy, type ComponentType } from "react";

// Keep the page usable as soon as its module is available. The initial
// navigation preloads it before replacing the server-rendered article.
export function routePage<P extends object>(load: () => Promise<{ default: ComponentType<P> }>) {
  let component: ComponentType<P> | undefined;
  let inflight: Promise<void> | undefined;
  const preload = () => inflight ??= load().then((module) => { component = module.default; }).catch((error) => { inflight = undefined; throw error; });
  const Lazy = lazy(async () => { await preload(); return { default: component! }; });
  const Page = (props: P) => component
    ? createElement(component, props)
    // This wrapper forwards ordinary page props, never a class-component ref.
    : createElement(Lazy as unknown as ComponentType<P>, props);
  Page.preload = preload;
  return Page;
}
